// extracted by mini-css-extract-plugin
export default {"card":"HelpCard_card__qfB1a","card__title":"HelpCard_card__title__Z87oi","card__description":"HelpCard_card__description__CSna8","card__footer":"HelpCard_card__footer__GItf9"};